import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { PmDialogComponent } from '@shared/components/pm-dialog/pm-dialog.component';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { IFormFieldConfig } from '../models/formConfig.model';
import { PmFormFieldComponent } from '../pm-form-field/pm-form-field.component';
import { Subscription, tap } from 'rxjs';
import { DatePickerYearChangeEvent } from 'primeng/datepicker';

@Component({
  standalone: true,
  selector: 'pm-mobile-form-field',
  imports: [CommonModule, PmDialogComponent, PmFormFieldComponent],
  templateUrl: './pm-mobile-form-field.component.html',
  styleUrl: './pm-mobile-form-field.component.scss',
})
export class PmMobileFormFieldComponent
  extends FormFieldComponent
  implements OnInit, OnDestroy
{
  @Output() valueChange = new EventEmitter();
  @Output() monthChanged = new EventEmitter<DatePickerYearChangeEvent>();

  selectedFormField: IFormFieldConfig | null = null;
  selectedValue: any = undefined;
  selectedValueLabel: any = undefined;
  initValue = '';

  dialogControl = new FormControl();

  private _subs = new Subscription();

  ngOnInit() {
    const validators = this.ctrl.validator ? [this.ctrl.validator] : [];
    const asyncValidators = this.ctrl.asyncValidator;
    if (asyncValidators) {
      this.dialogControl.addAsyncValidators(asyncValidators);
    }
    this.dialogControl.setValidators(validators);
    this.dialogControl.setValue(this.ctrl.value);
    this.dialogControl.updateValueAndValidity();
    this.initValue = this.ctrl.value;
    this.selectedValue = this.ctrl.value;
    this.setSelectedValueLabel();

    const sub = this.ctrl.valueChanges
      .pipe(
        tap((res) => {
          this.dialogControl.setValue(res);
        })
      )
      .subscribe();
    this._subs.add(sub);
  }

  onMobileFormFieldClick() {
    this.selectedFormField = this.formField;
  }

  onDialogCloseEvent() {
    this.dialogControl.setValue(this.initValue);
    this.selectedFormField = null;
  }

  onDialogSaveEvent() {
    this.selectedValue = this.dialogControl.value;
    this.ctrl.setValue(this.dialogControl.value);
    this.initValue = this.dialogControl.value;
    this.setSelectedValueLabel();
    this.selectedFormField = null;
    this.valueChange.emit(this.dialogControl.value);
  }

  setSelectedValueLabel() {
    if (this.selectedValue === null || this.selectedValue === undefined) {
      this.selectedValueLabel = null;
      return;
    }
    if (this.selectedValue && this.formField.options?.length) {
      this.selectedValueLabel = this.formField.options.find(
        (o: any) => o.value === this.selectedValue
      )?.label;
    } else if (
      this.isDate(this.selectedValue) &&
      this.formField.type === this.FormFieldTypeEnum.TIME
    ) {
      this.selectedValueLabel = this.toTime(this.selectedValue, true);
    } else if (this.formField.type === this.FormFieldTypeEnum.SLIDER) {
      if (this.formField.range && typeof this.selectedValue === 'object') {
        const values = Object.values(this.selectedValue);
        this.selectedValueLabel = `${
          this.formField.prefix ? this.formField.prefix : ''
        }${values[0]}${this.formField.suffix ? this.formField.suffix : ''} - ${
          this.formField.prefix ? this.formField.prefix : ''
        }${values[1]}${this.formField.suffix ? this.formField.suffix : ''}`;
      } else {
        this.selectedValueLabel = this.selectedValue;
      }
    } else {
      this.selectedValueLabel = this.selectedValue;
    }
  }

  isDate(value: any) {
    return (
      typeof value === 'object' && new Date(value).toString() !== 'Invalid Date'
    );
  }

  onMonthChanged($event: DatePickerYearChangeEvent) {
    this.monthChanged.emit($event);
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
